import api from './api';

export interface SucursalXUsuario {
  usuario: string;
  nroSuc: number;
  preferida: boolean;
  nombreSucursal?: string | null;
  idCompania?: string | null;
}

export interface SucursalXUsuarioSearchParams {
  searchTerm?: string;
  pageNumber: number;
  pageSize: number;
  usuario?: string;
  nroSuc?: number;
}

export interface SucursalXUsuarioPagedResult {
  items: SucursalXUsuario[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

export interface MisSucursalesResponse {
  items: SucursalXUsuario[];
  preferidaNroSuc?: number | null;
  esAdmin: boolean;
  sinAsignaciones: boolean;
}

const sucursalXUsuarioService = {
  getPaged: async (params: SucursalXUsuarioSearchParams): Promise<SucursalXUsuarioPagedResult> => {
    const response = await api.get<SucursalXUsuarioPagedResult>('/api/SucursalXUsuario', {
      params: {
        SearchTerm: params.searchTerm,
        PageNumber: params.pageNumber,
        PageSize: params.pageSize,
        Usuario: params.usuario,
        NroSuc: params.nroSuc,
      },
    });
    return response.data;
  },

  getByUsuario: async (usuario: string): Promise<SucursalXUsuario[]> => {
    const response = await api.get<SucursalXUsuario[]>(
      `/api/SucursalXUsuario/usuario/${encodeURIComponent(usuario)}`
    );
    return response.data;
  },

  getMias: async (): Promise<MisSucursalesResponse> => {
    const response = await api.get<MisSucursalesResponse>('/api/SucursalXUsuario/mias');
    return response.data;
  },

  create: async (dto: { usuario: string; nroSuc: number }): Promise<SucursalXUsuario> => {
    const response = await api.post<SucursalXUsuario>('/api/SucursalXUsuario', dto);
    return response.data;
  },

  setPreferida: async (nroSuc: number, usuario: string): Promise<void> => {
    await api.put(`/api/SucursalXUsuario/${nroSuc}/${encodeURIComponent(usuario)}/preferida`);
  },

  delete: async (nroSuc: number, usuario: string): Promise<void> => {
    await api.delete(`/api/SucursalXUsuario/${nroSuc}/${encodeURIComponent(usuario)}`);
  },
};

export default sucursalXUsuarioService;
